import { Link } from "react-router-dom";

export default function Splash() {
  return (
    <div className="site center splash-page">
      <main className="splash">
        <div className="splash-suits" aria-hidden="true">♠ ♥ ♦ ♣</div>
        <h1 className="splash-title">Better Your Blackjack</h1>
        <p className="splash-tag">
          Sharpen your blackjack game. Keep the count through realistic shoes,
          get graded against count-aware strategy — basic plays, the Illustrious 18,
          the Fab 4 — and review every decision after the shuffle.
        </p>
        <div className="splash-actions">
          <Link className="sbtn primary" to="/signup">Create account</Link>
          <Link className="sbtn" to="/login">Log in</Link>
        </div>
        <p className="splash-fine">
          A training tool. No real-money play, no prizes — just skill.
        </p>
      </main>
      <p className="splash-legal">
        <a href="/privacy.html">Privacy Policy</a>
        <span aria-hidden="true"> &middot; </span>
        <a href="/terms.html">Terms of Service</a>
      </p>
    </div>
  );
}
